import { useTenderActionError } from "../../../../hooks/useTenderActionError";
import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import { Aviation, Expeditor, Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import OrderBookingCard from "../../../../pages/orders/booking/OrderBookingCard";
import AccessDeniedModal from "../../../shared/SubscriptionModal/AccessDeniedModal";
import { t } from "i18next";
import { CURRENCIES, WEIGHT_UNITS } from "../../../../mock";
import CustomInputCurrency from "../../../custom/custom-input-currency/CustomInputCurrency";
import CustomInput from "../../../custom/custom-input/CustomInput";
import ArrowDownIcon from "../../../shared/icons/ArrowDownIcon";
import CommentIcon from "../../../shared/icons/CommentIcon";
import DeleteNewIcon from "../../../shared/icons/DeleteNewIcon";

const OrderBidOrBook = ({ item, cargoDetails, user, orderId, onUpdateData, fetchOrderData }) => {
  const { requestErrorDisplay } = useTenderActionError(item || { id: orderId }, { onRefreshOrder: fetchOrderData });
  const [isBooked, setBookedState] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [getOrder, setOrder] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSuggestPrice, setSuggest] = useState(false);
  const [suggestPrice, setSuggestPrice] = useState("");
  const [suggestVolume, setSuggestVolume] = useState("");
  const [suggestWeight, setSuggestWeight] = useState("");
  const [suggestWeightUnit, setSuggestWeightUnit] = useState(() => ({ ...WEIGHT_UNITS(t).ton }));
  const [initialVolume, setInitialVolume] = useState("");
  const [initialWeight, setInitialWeight] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isDisplayModal, changeDisplayModal] = useState(false);
  const [previousData, setPreviousData] = useState([]);
  const [currency, setCurrency] = useState("KZT");
  const [comment, setComment] = useState("");
  const [priceIdToDelete, setPriceIdToDelete] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [loadingRemoving, setLoadingRemoving] = useState(false);
  const [activeCommentId, setActiveCommentId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);


  useEffect(() => {
    setPreviousData("");
    if (!item) return;
    Expeditor.getOrderBidsByExpeditor(item.id)
      .then((response) => setPreviousData(response?.data))
      .catch((error) => console.log(error));
  }, [item]);

  useEffect(() => {
    if (!cargoDetails) return;
    const volumeSource = cargoDetails.volume;
    const weightSource = cargoDetails.weight;
    setInitialVolume(volumeSource !== undefined && volumeSource !== null ? String(volumeSource) : "");
    setInitialWeight(weightSource !== undefined && weightSource !== null ? String(weightSource) : "");
    const unitValue = cargoDetails.unitMeasurement !== undefined && cargoDetails.unitMeasurement !== null ? String(cargoDetails.unitMeasurement) : "Kg";
    
    if(unitValue === "Ton") { 
      setSuggestWeightUnit(WEIGHT_UNITS(t).ton);
    }
    else if(unitValue === "Kg") {
      setSuggestWeightUnit(WEIGHT_UNITS(t).kg);
    }
  }, [cargoDetails]);

  const handleSuggestPrice = () => {
    const roundedPrice = Math.round(Number(suggestPrice));

    if (!roundedPrice) {
      setErrorText("Введите цену");
      return;
    }
    if (roundedPrice <= 0) {
      setErrorText("Введите корректную положительную цену");
      return;
    }
    if (roundedPrice > 2000000000) {
      setErrorText(t("ordersCreate.validation.priceTooLargeError"));
      toast.error(t("ordersCreate.validation.priceTooLargeError"));
      return;
    }

    setErrorText("");
    setLoading(true);

    const data = {
      orderId: orderId,
      price: roundedPrice,
      currency: currency,
      comments: comment.trim(),
      volume: (suggestVolume === "" ? initialVolume : suggestVolume) !== "" ? Number(suggestVolume === "" ? initialVolume : suggestVolume) : null,
      weight: (suggestWeight === "" ? initialWeight : suggestWeight) !== "" ? Number(suggestWeight === "" ? initialWeight : suggestWeight) : null,
    };

    // const request = !previousPrice?.id
    //   ? Expeditor.sendOrderBids(data)
    //   : Expeditor.updateOrderBid(previousPrice?.id, data);

    Expeditor.sendOrderBids(orderId, data)
      .then(() => {
        setLoading(false);
        toast.success(t("orderInfo.suggestPrice.suggestSuccess"));
        onUpdateData();
      })
      .catch(async (error) => {
        setLoading(false);
        console.error("Ошибка при отправке цены:", error);
        setErrorText(t("orderInfo.suggestPrice.suggestError"));
        await requestErrorDisplay(error, t, "orderInfo.suggestPrice.suggestError");
      });
  };

  const handleConfirmDelete = async () => {
    if (!priceIdToDelete) return;
    try {
      setLoadingRemoving(true);
      await Expeditor.deleteOrderBid(priceIdToDelete);
      toast.success(t("orderInfo.suggestPrice.deleteSuccess"));

      setPreviousData((prev) => prev.filter((p) => p.id !== priceIdToDelete));
      onUpdateData();

      setPriceIdToDelete(null);
    } catch (error) {
      await requestErrorDisplay(error, t, "orderInfo.suggestPrice.deleteError");
      console.error("Ошибка при удалении:", error);
    } finally {
      setLoadingRemoving(false);
      setShowConfirmDelete(false);
    }
  };

  const fetchOrderDataById = async () => {
    setLoading(true);
    try {
      const { data } = await Order.getOrderForExpeditor({ orderId });
      setBookedState(data.isBooked);
      setOrder(data.order);
      if (data.vehicle && data.driver) {
        getBookData({
          driver: data.driver,
          transport: data.vehicle,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getBookData = ({ driver, transport }) => {
    setDrivers([
      {
        ...driver,
        vehicle: transport,
      },
    ]);
  };

  const sendOrderBooking = async () => {
    setLoading(true);

    try {
      const driver = drivers[0] || {};
      const body = {
        driverId: driver.id,
        vehicleId: driver.vehicle?.id,
      };
      await Order.sendOrderBookPub(getOrder.id, body);
      toast.success("Водитель успешно назначен");
      setIsOpenModal(false);
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      toast.error("Произошла ошибка, попробуйте позже");
      console.error("Ошибка при назначении водителя", e);
    } finally {
      setLoading(false);
    }
  };

  const toggleComment = (priceId) => {
    setActiveCommentId((prevId) => (prevId === priceId ? null : priceId));
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };


  const onDeleteDriver = (driver) => {
    if (isBooked) {
      // onCancelBooking()
    } else {
      setDrivers(drivers.filter((d) => d.id !== driver.id));
    }
  };

  useEffect(() => {
    fetchOrderDataById();
  }, [orderId]);

  return (
    <div className={cn(style.cargo_wrapper)}>
      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

      <div className={style.bidGridActions}>
        <div>
          <CustomButton
            text={t("orderInfo.bookOrder")}
            style={{ width: "100%" }}
            onClick={() => {
            if (user?.state === "Pending") {
              return toast.info("Вы не можете забронировать заказ, необходимо загрузить документы");
            }
            if (user?.state === "Moderation") {
              return toast.info(
                "Вы не можете забронировать заказ, модератор еще не подтвердил ваши документы",
              );
            }
            if (user?.state !== "Confirmed") {
              return toast.info("Вы не можете забронировать заказ, необходимо пройти верификацию");
            }
            if (user && user.permissions?.includes("restricted_view")) {
              return changeDisplayModal(true);
            }
            setIsOpenModal(true);
            setSuggestPrice("");
            setSuggest(false);
            }}
            isLoading={isLoading}
          />
        </div>
        <div className={style.colSpan2}>
          <CustomButton
            text={t("orderInfo.suggestYourPriceButton")}
            style={{ width: "100%" }}
            onClick={() => {
            if (user?.state === "Pending") {
              return toast.info("Вы не можете предложить свою цену, необходимо загрузить документы");
            }
            if (user?.state === "Moderation") {
              return toast.info(
                "Вы не можете предложить свою цену, модератор еще не подтвердил ваши документы",
              );
            }
            if (user?.state !== "Confirmed") {
              return toast.info("Вы не можете предложить свою цену, необходимо пройти верификацию");
            }
            if (user && user.permissions?.includes("restricted_view")) {
              return changeDisplayModal(true);
            }
            setSuggest(true);
            setSuggestVolume("");
            setSuggestWeight("");
            }}
            isLoading={isLoading}
          />
        </div>
      </div>

      {isSuggestPrice && (
        <div className={style.form_section}>
          {previousData && previousData.length > 0 && (
            <div className={style.suggested_infoRow} style={{marginBottom: "20px"}}>
              <div className={style.suggested_priceList}>
                {previousData.length > 3 ? (
                  <>
                    <button onClick={toggleExpanded} className={style.suggested_priceToggle}>
                      <span>Ваши предыдущие ставки ({previousData.length})</span>
                      <ArrowDownIcon isExpanded={isExpanded} stroke="#000" />
                    </button>

                    {isExpanded && (
                      <div className={style.suggested_priceContainer}>
                        {previousData.map((priceItem) => (
                          <div key={priceItem.id}>
                            <div className={style.suggested_priceItem}>
                              <div className={style.suggested_priceLine}>
                                <span className={style.suggested_priceValue}>
                                  {priceItem.price} {CURRENCIES[priceItem.currency]?.symbol || priceItem.currency}
                                </span>
                                {priceItem.volume !== undefined && priceItem.volume !== null && (
                                  <span className={style.suggested_priceMeta}>
                                    {priceItem.volume} {t('ordersCreateDesktop.detailsSection.volumeUnit')}<sup>3</sup>
                                  </span>
                                )}
                                {priceItem.weight !== undefined && priceItem.weight !== null && (
                                  <span className={style.suggested_priceMeta}>
                                    {priceItem.weight} {t('orderInfo.ordersInfoCargo.kgUnit')}
                                  </span>
                                )}
                              </div>
                              <div className={style.suggested_priceActions}>
                                {priceItem.comments && (
                                  <div
                                    onClick={() => toggleComment(priceItem.id)}
                                    className={style.suggested_iconButton}
                                  >
                                    <CommentIcon />
                                  </div>
                                )}
                                <div
                                  className={cn(
                                    style.suggested_iconButton,
                                    style.suggested_iconButton__delete,
                                  )}
                                >
                                  <DeleteNewIcon
                                    onClick={() => {
                                      setShowConfirmDelete(true);
                                      setPriceIdToDelete(priceItem.id);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {activeCommentId === priceItem.id && priceItem?.comments && (
                              <div className={style.suggested_comment}>{priceItem.comments}</div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <div className={style.suggested_priceContainer}>
                    {previousData.map((priceItem) => (
                      <div key={priceItem.id}>
                        <div className={style.suggested_priceItem}>
                          <div className={style.suggested_priceLine}>
                            <span className={style.suggested_priceValue}>
                              {priceItem.price} {CURRENCIES[priceItem.currency]?.symbol || priceItem.currency}
                            </span>
                            {priceItem.volume !== undefined && priceItem.volume !== null && (
                              <span className={style.suggested_priceMeta}>
                                {priceItem.volume} {t('ordersCreateDesktop.detailsSection.volumeUnit')}<sup>3</sup>
                              </span>
                            )}
                            {priceItem.weight !== undefined && priceItem.weight !== null && (
                              <span className={style.suggested_priceMeta}>
                                {priceItem.weight} {cargoDetails?.unitMeasurement === "Kg" ? t("orderInfo.ordersInfoCargo.kgUnit") : t("orderInfo.ordersInfoCargo.tonsUnit")}
                              </span>
                            )}
                          </div>
                          <div className={style.suggested_priceActions}>
                            {priceItem.comments && (
                              <div
                                onClick={() => toggleComment(priceItem.id)}
                                className={style.suggested_iconButton}
                              >
                                <CommentIcon />
                              </div>
                            )}
                            <div
                              className={cn(
                                style.suggested_iconButton,
                                style.suggested_iconButton__delete,
                              )}
                            >
                              <DeleteNewIcon
                                onClick={() => {
                                  setShowConfirmDelete(true);
                                  setPriceIdToDelete(priceItem.id);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {activeCommentId === priceItem.id && priceItem?.comments && (
                          <div className={style.suggested_comment}>{priceItem.comments}</div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSuggestPrice();
            }}
          >
            <div className={style.form_group}>
              <div className={style.bidGridFormRow}>
                <div>
                  <CustomInputCurrency
                    value={suggestPrice}
                    isBgGray
                    inputType="number"
                    labelText={t("orderInfo.suggestPrice.yourPriceLabel") + "*"}
                    placeholder={t("orderInfo.yourPricePlaceholder")}
                    errorText={errorText}
                    currency={currency}
                    onChangeValue={(value) => {
                      setSuggestPrice(value);
                      setErrorText("");
                    }}
                    onChangeCurrency={(currencyCode) => {
                      setCurrency(currencyCode);
                    }}
                  />
                </div>
                <div>
                  <CustomInput
                    inputType="number"
                    isBgGray
                    labelText={t('ordersCreateDesktop.detailsSection.volumeLabel')}
                    prefixEnd={
                      <span>
                        {t('ordersCreateDesktop.detailsSection.volumeUnit')}<sup>3</sup>
                      </span>
                    }
                    value={suggestVolume}
                    placeholder={initialVolume}
                    onChangeValue={(v) => setSuggestVolume(v)}
                  />
                </div>
                <div>
                  <CustomInput
                    labelText={t('ordersCreateDesktop.detailsSection.weightLabel')}
                    isBgGray={true}
                    prefixEnd=
                    {
                      <span>
                        {suggestWeightUnit.code === "Kg" ? t("orderInfo.ordersInfoCargo.kgUnit") : t("orderInfo.ordersInfoCargo.tonsUnit")}
                      </span>
                    }
                    inputType="number"
                    value={suggestWeight}
                    placeholder={initialWeight}
                    onChangeValue={(v) => setSuggestWeight(v)}
                  />
                </div>
              </div>
            </div>

            <div className={style.form_group}>
              <label className={style.form_label} htmlFor="comment">
                {t("orderInfo.suggestPrice.commentLabel", "Комментарий к предложению")}
                <span className={style.optional_label}>
                  {t("orderInfo.suggestPrice.optional", "(необязательно)")}
                </span>
              </label>
              <textarea
                id="comment"
                className={style.form_textarea}
                value={comment}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 500) {
                    setComment(value);
                  }
                }}
                placeholder={t(
                  "orderInfo.suggestPrice.commentPlaceholder",
                  "Укажите дополнительную информацию о вашем предложении, условиях поставки, скидках и т.д.",
                )}
                maxLength={500}
              />
              <div className={style.char_counter}>
                <span>{comment.length}</span> / 500
              </div>
            </div>

            <CustomButton
              text={t("orderInfo.suggestPrice.suggestButton")}
              style={{ flex: "1", width: "100%" }}
              type="submit"
              isLoading={isLoading}
            />
          </form>
        </div>
      )}
      {isOpenModal && (
        <div className={cn("modal-overlay", style.modal)}>
          <div className={style.modal_content}>
            <OrderBookingCard
              driver={drivers[0]}
              companyId={user?.companyId}
              orderId={orderId}
              onDelete={onDeleteDriver}
              isBooked={isBooked}
              getDataSubmit={getBookData}
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              onSubmitBooking={sendOrderBooking}
            />
          </div>
        </div>
      )}

      {showConfirmDelete && (
        <div className={style.confirmModalOverlay}>
          <div className={style.confirmModal}>
            <p>{t("orderInfo.suggestPrice.confirmDelete")}</p>
            <div className={style.confirmModal_actions}>
              <CustomButton
                isWhite
                text={t("common.cancel")}
                onClick={() => {
                  setShowConfirmDelete(false);
                }}
              />
              <CustomButton
                text={t("common.confirm")}
                onClick={handleConfirmDelete}
                isLoading={loadingRemoving}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderBidOrBook;
